import { LanguageContext } from 'components/MainComponent/MainComponent'
import { scaleLinear } from 'd3-scale'
import { useContext, useMemo } from 'react'
import styled from 'styled-components'
import { useElementSize } from 'usehooks-ts'
const histodata = [
  { dist_group_trunc: '1000', pop_group: 2004824, nr: 1, g: 1000 },
  { dist_group_trunc: '2000', pop_group: 1702657, nr: 2, g: 2000 },
  { dist_group_trunc: '3000', pop_group: 1397986, nr: 3, g: 3000 },
  { dist_group_trunc: '4000', pop_group: 1017879, nr: 4, g: 4000 },
  { dist_group_trunc: '5000', pop_group: 688419, nr: 5, g: 5000 },
  { dist_group_trunc: '6000', pop_group: 494750, nr: 6, g: 6000 },
  { dist_group_trunc: '7000', pop_group: 359159, nr: 7, g: 7000 },
  { dist_group_trunc: '8000', pop_group: 244410, nr: 8, g: 8000 },
  { dist_group_trunc: '9000', pop_group: 190681, nr: 9, g: 9000 },
  { dist_group_trunc: "10'000", pop_group: 141634, nr: 10, g: 10000 },
  { dist_group_trunc: "11'000", pop_group: 116163, nr: 11, g: 11000 },
  { dist_group_trunc: "12'000", pop_group: 82002, nr: 12, g: 12000 },
  { dist_group_trunc: "13'000", pop_group: 59546, nr: 13, g: 13000 },
  { dist_group_trunc: "14'000", pop_group: 52308, nr: 14, g: 14000 },
  { dist_group_trunc: "15'000", pop_group: 37278, nr: 15, g: 15000 },
  { dist_group_trunc: "> 15'000", pop_group: 168199, nr: 16, g: 10000000 },
]

const leftLabesWidth = 80
const maxY = 360
const minY = 55
const xTicks = [0, 500000, 1000000, 1500000, 2000000]
export const Histogramm = ({
  selectedKmPop,
}: {
  selectedKmPop: number | undefined
}) => {
  const [container, { width, height }] = useElementSize()
  const markedGroupo = selectedKmPop
    ? histodata.find((d) => d.g >= selectedKmPop)
    : undefined
  console.log(selectedKmPop, markedGroupo)
  const x = useMemo(
    () =>
      scaleLinear()
        .domain([0, 2100000])
        .range([0, width - leftLabesWidth]),
    [width]
  )
  const y = useMemo(
    () => scaleLinear().domain([0, 16]).range([minY, height]),
    [height]
  )


  const Locales = useContext(LanguageContext)
  console.log("mapactive",(window as any).mapactive)

  return (
    <HistogrammRoot>
      <Title>{Locales.histoTitle}</Title>
      <Container ref={container} style={{ height: maxY }}>
        {width > 0 && (
          <SVG height={maxY}>
            <g transform={`translate(${leftLabesWidth},0)`}>
              <g>
                {xTicks.map((m, i) => {
                  return (
                    <g key={'a' + i}>
                      <line
                        x1={x(m)}
                        x2={x(m)}
                        y1={i === 0 ? 0 : minY - 15}
                        y2={height * (i > 0 && m >= 1000000 ? 0.6 : 1)}
                        stroke={
                          m === 0
                            ? 'var(--text-color)'
                            : 'var(--tick-line-color)'
                        }
                      />
                      {i > 0 && !m.toString().includes('5') && (
                        <text
                          fill='var(--tick-label-color)'
                          x={x(m)}
                          y={y.range()[0] - 25}
                          textAnchor={
                            i === xTicks.length - 1 ? 'end' : 'middle'
                          }
                        >
                          {m === 1000000 ? '1 Mio.' : '2 Mio.'}
                        </text>
                      )}
                    </g>
                  )
                })}
              </g>
              <g>
                {histodata.map((d, i) => {
                  return (
                    <g transform={`translate(0,${y(i)})`} key={'b' + i}>
                      {i % 3 === 0 && (
                        <text
                          fill='var(--tick-label-color)'
                          textAnchor='end'
                          y={
                            i === histodata.length - 1
                              ? 13
                              : maxY / histodata.length
                          }
                          x={-10}
                        >
                          {d.dist_group_trunc}
                        </text>
                      )}
                      <rect
                        width={x(d.pop_group)}
                        height={(height / histodata.length) * 0.78}
                        x={0.5}
                        fill={
                          markedGroupo?.nr === d.nr
                            ? 'var(--yellow-main)'
                            : i === histodata.length - 1
                            ? 'var(--last-bar-color)'
                            : 'var(--other-bars-color)'
                        }
                      />
                    </g>
                  )
                })}
              </g>
              <g>
                <text
                  fill='var(--text-color)'
                  x={x(xTicks[xTicks.length - 1])}
                  y={y.range()[0] - 42}
                  fontSize={14}
                  textAnchor='end'
                >
                  {Locales.histoLabelHori}
                </text>
                <text
                  fill='var(--text-color)'
                  x={-10}
                  y={y.range()[0] - 42}
                  fontSize={14}
                  textAnchor='end'
                >
                  <tspan>{Locales.histoLabelVert[0]}</tspan>
                  <tspan dy={17} x={-10}>
                    {Locales.histoLabelVert[1]}
                  </tspan>
                </text>
              </g>{' '}
            </g>
          </SVG>
        )}
      </Container>
    </HistogrammRoot>
  )
}

const Container = styled.div`
  width: 100%;
`

const SVG = styled.svg`
  width: 100%;
  height: ${maxY + 60}px;
  font-family: var(--font-sans-serif);
  font-size: 12px;
`

const Title = styled.div`
  flex: 0 0 100%;
  font-family: var(--font-sans-serif);
  font-weight: 700;
  line-height: 1.2em;
  margin-bottom: 30px;
`
const HistogrammRoot = styled.div`
  margin-top: 30px;
  margin-bottom: 60px;
  width: 100%;
  position: relative;
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  padding: 0;
  z-index: 0;
  @media screen and (max-width: 711px) {
    width: calc(100% - 0px);
  }
`
